import React from "react";

import "../../style/checkbox.module.css";

type CheckBoxProps = Omit<JSX.IntrinsicElements["input"], "type"> & {
    color: "primary";
};

export default function CheckBox(props: CheckBoxProps) {
    const { className } = props;
    return (
        <input
            {...props}
            className={`${className} ${props.color === "primary" ? "primary-checkbox" : ""}`}
            type="checkbox"
        />
    );
}
